export const SHOP_SOURCES = {
    JCR: "jcr",
    SFCC: "salesforce-sfcc",
    COMMERCETOOLS: "commercetools",
};
